package game

class TalentsSelectionValidator(
    private val talentSelections: Map<Talents, Int>
) {

//    fun canSelect(talent: Talents): Boolean {
//
//    }

}

typealias TalentSelectionRule = (Map<Talents, Int>) -> Boolean

infix fun Talents.hasCount(count: Int): TalentSelectionRule = { talents ->
    (talents[this] ?: 0) >= count
}

fun Talents.isFullUpgraded(): TalentSelectionRule = { talents ->
    (talents[this] ?: 0) == this.upgradeCount
}

val ALWAYS_ACCEPT: TalentSelectionRule = { true }
val ALWAYS_DENIED: TalentSelectionRule = { false }
